import {
  type ClinicClock,
  clinicClock,
  dayMarker,
  pickedDay,
} from "@/lib/clinic-clock";

import { TimeOfDay } from "@/types/self-schedule";

export const waitlistTimePreferenceLabels: Record<TimeOfDay | "any", string> = {
  any: "Any time",
  morning: "Morning (5 am–noon)",
  afternoon: "Afternoon (noon–5 pm)",
  evening: "Evening (5 pm–5 am)",
};

const PREFERENCE_START_HOUR: Record<TimeOfDay, number> = {
  morning: 9,
  afternoon: 12,
  evening: 17,
};

// Matches SchedulingService's self-schedule grouping, including overnight
// hours in evening, read on the clinic's clock.
export function waitlistTimeOfDay(
  moment: Date,
  clock: ClinicClock = clinicClock(),
): TimeOfDay {
  const hour = Math.floor(clock.wallMinutes(moment) / 60);
  if (hour >= 5 && hour < 12) return "morning";
  if (hour >= 12 && hour < 17) return "afternoon";
  return "evening";
}

export function matchesWaitlistTime(
  preference: TimeOfDay | null | undefined,
  moment: Date,
  clock: ClinicClock = clinicClock(),
): boolean {
  return !preference || preference === waitlistTimeOfDay(moment, clock);
}

// Seed a usable daytime start for restricted toolbar entries. The toolbar
// remains date-only and never filters entries by its displayedDate's hour.
// `date` is the calendar's day (a picker marker) or a concrete slot; the
// start lands on that day at the clinic's clock time.
export function waitlistBookingStart(
  date: Date,
  preference: TimeOfDay | null | undefined,
  clock: ClinicClock,
): Date {
  const isDayOnly = dayMarker(pickedDay(date)).getTime() === date.getTime();
  const day = isDayOnly ? pickedDay(date) : clock.dayOf(date);
  if (preference) return clock.at(day, PREFERENCE_START_HOUR[preference] * 60);
  // Date-only toolbar selection: use the existing morning default, never
  // midnight. Recovery/clicked slots with a concrete time stay unchanged.
  return isDayOnly ? clock.at(day, 9 * 60) : new Date(date);
}
